import { useTranslation } from 'react-i18next';

const AboutPageDetails = () => {
  const { t } = useTranslation();
  return (
    <section className='grid w-full place-items-center'>
      <div className=' text-left text-black '>
        <div className='w-full bg-yellow-200 shadow-2xl'>
          <h1 className='px-8 py-4 text-[1rem] font-bold leading-8 sm:text-[1.125rem] break16:px-80'>{t('erentConnectsPeople')}</h1>
        </div>
        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem] font-medium leading-8 max-sm:py-4 sm:text-[1rem] break16:px-80'>{t('timeIsVeryPrecious')}</p>
        <br />
        <div className='w-full bg-yellow-200 shadow-2xl'>
          <h1 className='px-8 py-4 text-[1rem] font-bold leading-8 sm:text-[1.125rem] break16:px-80'>{t('erentDoesNotCharge')}</h1>
        </div>

        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem]  font-medium leading-8 max-sm:py-4 sm:text-[1rem] break16:px-80'>
          {t('maybeWasJustUnlucky')}
          <span className='font-bold'>{t('owner')}</span>
          {t('willAlways')}
          <span className='font-bold'>{t('ownerUser')}</span>
          {t('willGetAll')}
        </p>
        <br />
        <div className='w-full bg-yellow-200 shadow-2xl'>
          <h1 className='px-8 py-4 text-[1rem] font-bold leading-8 sm:text-[1.125rem] break16:px-80'>{t('erentIsSimplePlace')}</h1>
        </div>

        <br className='max-sm:hidden' />
        <p className='px-8  text-[0.8rem] font-medium leading-8 max-sm:py-4 sm:text-[1rem] break16:px-80'>{t('apartmentsHousesRafts')}</p>
        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem] font-medium leading-8 max-sm:pb-8 sm:text-[1rem] break16:px-80'>{t('photographersMusicBands')}</p>
        <br className='max-sm:hidden' />
        <div className='w-full bg-yellow-200  shadow-2xl'>
          <h1 className='px-8 py-4 text-[1rem] font-bold leading-8 sm:text-[1.125rem] break16:px-80'>{t('inAddition')}</h1>
        </div>
        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem] font-medium leading-8 max-sm:py-4 sm:text-[1rem] break16:px-80'>{t('eRentWillBecomeYour')}</p>
        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem] font-medium leading-8 sm:text-[1rem] break16:px-80'>{t('withCertaintyOfThat')}</p>
        <br className='max-sm:hidden' />
        <p className='px-8 text-[0.8rem] font-medium leading-8 sm:text-[1rem] break16:px-80'>Jasmina Tomašević</p>
        <h1 className='px-8 text-[1rem] font-bold leading-8 sm:text-[1.125rem] break16:px-80'>E-RENT</h1>
      </div>
    </section>
  );
};

export default AboutPageDetails;
